
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/skigebieden",
      function () {
        return require("private-next-pages/[region]/skigebieden.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/skigebieden"])
      });
    }
  